import React from "react";

import classes from "./spinner.module.css";

const Spinner = () => {
    return <div className={classes.spinner}></div>;
};

export default Spinner;
